export const MAX_FILE_SIZE = 500 * 1024 * 1024; // 500 MB
export const MAX_FILES_UPLOAD = 4; // 4 files at one time
export const MAX_TOTAL_FILES = 5000; // 5000 files per customer

export const acceptedFileTypes = {
    "application/pdf": [".pdf"],
    "text/plain": [".txt"],
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [".docx"],
    "image/jpeg": [".jpg", ".jpeg"],
    "image/png": [".png"],
    "image/webp": [".webp"],
    "image/heic": [".heic"],
    "text/csv": [".csv"],
    "application/vnd.ms-excel": [".xls"],
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".xlsx"],
};
